import React, { Component } from 'react';
import {
    Link, withRouter
} from 'react-router-dom';
import '../../stylesheet/imagehover.css'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import ProfileUpdateModal from './profileupdate.jsx'
import Autosuggest from 'react-autosuggest';
import Loader from '../loader/loader.jsx'
import cityimg from '../../images/City.svg'
import postalimg from '../../images/post-office.png'
import Subhadatta from '../../images/subhadatta.jpg'
import defaultImage from '../../images/default.gif'
import LoaderSmall from "../loader/loadersmall.jsx"
import s from '../../services/allservices.jsx'
import { connect } from 'react-redux'
import * as actions from '../../actions/actions.jsx'
import '../../stylesheet/personalinfo.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import $ from 'jquery'
import { Button } from 'mdbreact';

import 'react-toastify/dist/ReactToastify.css';
const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid rgb(224, 224, 224)",
        bottom: "22px",
        position: "relative",
        width: "100%"

    }
};

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');


const getSuggestions = (value, countryState) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
        return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    const suggestions = countryState.filter(country => regex.test(country.name));

    if (suggestions.length === 0) {
        return [
            { name: "No Country Found" }
        ];
    }

    return suggestions;
}

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        profileState: state.getProfileReducer.profileState,
        cardState: state.getCardReducer.cardState,
        countryState: state.countryReducer.countryState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchProfileState() {
            dispatch(
                actions.getProfileAction()
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
        fetchCountryState() {
            dispatch(
                actions.countryAction()
            )
        }
    })
const JSEncrypt = window.JSEncrypt
class PersonalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: localStorage.getItem('address'),
            basic: true,
            contact: true,
            disabled: true,
            disabledmail: true,
            disabledmailempty: true,
            disabledcontact: true,
            mailing: true,
            emailState: true,
            cityState: true,
            correcthome: true,
            correctstate: true,
            correctphone: true,
            correctEmail: true,
            correctpasscode: true,
            pincodeState: true,
            phoneState: true,
            dateofbirth: '',
            correctcountry: true,
            correctMCity: true, correctMpasscode: true, correctMadd: true, correctMstate: true, correctMcountry: true,
            coreectfirstName: true, coreectdateofbirth: true,
            firstName: '',
            lastName: '',
            gender: '',
            emailId: '',
            city: '',
            pincode: '',
            mpincode: '',
            correctCity: true,
            selectedCard: [],
            cardDetailsId: "",
            suggestions: [],
            value: '',
            country: '',
            countryCode: '',
            country1: '',
            countryCode1: '',
            value2: '',
            value3: '',
            value4: '',
            value5: '',
            maddress: '',
            maddress2: '',
            photoURL: '',
            mediaInfo: '',
            stateState: true,
            state1: '',
            address1: '',
            correctadd: true,
            addState: true,
            homeState: true,
            dateSelected: false,
            genderSelected: false
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleBasic = this.handleBasic.bind(this)
        this.handleContact = this.handleContact.bind(this)
        this.handleMailing = this.handleMailing.bind(this)
        this.handleContactSubmit = this.handleContactSubmit.bind(this)
        this.handleMailingSubmit = this.handleMailingSubmit.bind(this)

    }
    componentDidMount() {
       
        const { publicKey, cardState } = this.props
        this.props.fetchProfileState();
        this.setState({
            emailId: cardState.body[0].emailId,
        })

        this.props.fetchCountryState()

        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)

            }
        }, 500);

    }
    componentWillMount() {
        this.props.fetchCountryState();
    }

    onChange1 = (event, { newValue, method }) => {
        let addval=  newValue.trim()
        if (newValue.name == "") {
            this.setState({
                disabledcontact: false
            })
        }
        else {
            this.setState({
                value3: newValue,
                disabledcontact: true
            })

        }
    };

    onChange2 = (event, { newValue, method }) => {
      let addval=  newValue.trim()
        if (newValue.name == " ") {
            this.setState({
                disabledmail: false
            })
        }
        else {
            this.setState({
                value2: newValue,
                disabledmail: true
            })

        }

    };
    removeemail = () => {
        this.setState({
            emailState: true
        })
    }
    removecity = () => {
        this.setState({
            cityState: true
        })
    }
    removepasscode = () => {
        this.setState({
            pincodeState: true
        })
    }

    removephone = () => {
        this.setState({
            phoneState: true
        })
    }

    removestate = () => {
        this.setState({
            stateState: true
        })
    }
    removeadd = () => {
        this.setState({
            addState: true
        })
    }
    removehome = () => {
        this.setState({
            homeState: true
        })
    }



    getSuggestionValue = suggestion => {
       
        // if(suggestion.name="No Country Found"){
        //     this.setState({
        //         correctcountry:false
        //     })
        // }
        this.setState({
            country: suggestion.name,
            countryCode: suggestion.alpha3Code
        }, () => {

        })
        return suggestion.name;
    };


    renderSuggestion = suggestion => {
        return suggestion.name || suggestion.name;
    };

    onSuggestionsFetchRequested = ({ value }) => {

        this.setState({
            suggestions: getSuggestions(value, this.props.countryState)
        }, () => {
           
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: this.state.country
        });
    };


    onSuggestionSelected1 = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        if (suggestionValue !== "" && suggestionValue !== "No Country Found") {

            this.setState({
                disabledmail: false
            })
        }
        else {
            this.setState({
                disabledmail: true
            })
        }
    };

    onSuggestionSelected2 = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        if (suggestionValue !== "" && suggestionValue !== "No Country Found") {

            this.setState({
                disabledmailempty: false,

            })
        }
        else {
            this.setState({
                disabledmailempty: true
            })
        }
    };
    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        if (suggestionValue !== "" && suggestionValue !== "No Country Found") {


            this.setState({
                disabledcontact: false,

            }, () => {
                if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                    this.setState({
                        disabledcontact: false
                    })
                } else {
                    this.setState({
                        disabledcontact: true
                    })
                }
            })
        }
        else {
            this.setState({
                disabledcontact: true
            })
        }
    };




    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }


    formatDate = (date) => {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    }
    handleDate = (e, date) => {
       
        // if(date !== null){
        this.setState({
            dateofbirth: this.converDate(date),
            dateSelected: true
        }, () => {
          
            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null && this.state.gender.length !== 0) {
                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        })
        // }
        // else{
        //     this.setState({
        //         dateofbirth:null,
        //         disabled: true
        //     }) 
        // }
    }

    handleGender = (event, index, value1) => {
       
        if (value1 !== null) {
            this.setState({
                gender: value1,
                genderSelected: true
            }, () => {
               
                if (this.state.firstName.length !== 0 && this.state.gender.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            });
        }
        else {
            this.setState({
                gender: "",
                disabled: true
            })
        }
    }
    handleLastName = (e, value) => {
       
        if (value.length !== 0) {
            this.setState({
                lastName: value
            }, () => {
               
                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null && this.state.gender.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
        else {
            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null && this.state.gender.length !== 0) {
                this.setState({
                    lastName: "",
                    disabled: false
                })
            }
            
        }
    }

    handleFirstName = (e, value) => {
       
      let addval=value.trim()
        if (e.target.name === "firstName" && value.length !== 0) {

            this.setState({

                firstName: addval,

            }, () => {
              

                if (this.state.firstName.length !== 0 && this.state.gender.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })

        } else {
            this.setState({
                firstName: "",
                disabled: true
            })
        }
    }
    handleMailingSubmit() {
        const { correctMCity, correctMpasscode, country, correctMadd, correctMstate, correctMcountry, mstate1, mpincode, mcity, maddress } = this.state
        const { profileState } = this.props

        if (correctMCity === false) {
            this.setState({
                correctMCity: false,
            })
        }
        else if (correctMpasscode === false) {
            this.setState({
                correctMpasscode: false,
            })
        }
        else if (correctMadd === false) {
            this.setState({
                correctMadd: false,
            })
        }
        else if (correctMstate === false) {
            this.setState({
                correctMstate: false,
            })
        }


        else {
            this.setState({
                loader: true
            })
            let state = {
                cardDetailsId: this.state.cardDetailsId,
                address: this.state.maddress,
                address2: this.state.maddress2,
                city: this.state.mcity,
                country: this.state.country || profileState.body.mailingInformation.country,
                countryCode: this.state.countryCode,
                mailingId: localStorage.getItem("mailingId"),
                memberId: localStorage.getItem("memberId"),
                pincode: this.state.mpincode,
                state: this.state.mstate1
            }
            let _this = this
            let token = "Token " + localStorage.getItem('token')
            if (state.address !== "" || state.address2 !== "" || state.city !== "" || state.country !== "" || state.pincode !== "" || state.state !== "") {
                this.setState({
                    loader: true
                })
                fetch(s.update_mailing + "/?Authorization=" + token, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {
                           
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            response.json().then(function (object) {
                                _this.props.fetchProfileState();
                                _this.setState({
                                    mailing: !_this.state.mailing
                                })
                            })
                            this.setState({
                                loader: false
                            })
                        } else {
                            this.setState({
                                loader: false
                            })
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })
            }
        }
    }

    handleContactSubmit() {
        const { correctCity, correctcountry, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props
        if (correctCity === false) {
            this.setState({
                correctCity: false,
            })
        }
        else if (correctEmail === false) {
            this.setState({
                correctEmail: false,
            })
        }
        else if (correctpasscode === false) {
            this.setState({
                correctpasscode: false,
            })
        } else if (correctadd === false) {
            this.setState({
                correctadd: false,
            })
        }
        else if (correctPhone === false) {
            this.setState({
                correctPhone: false,
            })
        } else if (correcthome === false) {
            this.setState({
                correcthome: false,
            })
        } else if (correctstate === false) {
            this.setState({
                correctstate: false,
            })
        }


        else {
            let state = {
                cardDetailsId: this.state.cardDetailsId,
                address: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                country: this.state.country || profileState.body.country,
                countryCode: this.state.countryCode,
                homePhoneNumber: this.state.homePhoneNumber,
                memberId: localStorage.getItem("memberId"),
                mobileNumber: this.state.mobileNumber,
                pincode: this.state.pincode,
                state: this.state.state1,
                emailId: this.state.emailId
            }
           
            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            fetch(s.update_contact + "/?Authorization=" + token, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        response.json().then(function (object) {

                            _this.props.fetchProfileState();
                            _this.setState({
                                contact: !_this.state.contact
                            })
                        })
                        this.setState({
                            loader: false
                        })
                    } else {
                        this.setState({
                            loader: true
                        })

                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });



                    }
                })
        }
    }
    handleSubmit = () => {
        const { email, coreectfirstName } = this.state
        const { profileState } = this.props
        if (coreectfirstName === false) {
            this.setState({
                coreectfirstName: false,
            })
        }
        else {
            const state = {
                applicationId: "gmcabs",
                cardDetailsId: this.state.cardDetailsId,
                dateofbirth: this.state.dateofbirth,
                firstName: this.state.firstName,
                gender: this.state.gender,
                lastName: this.state.lastName,
                memberId: localStorage.getItem("memberId")
            }
           
            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            fetch(s.update_basic + "/?Authorization=" + token, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        response.json().then(function (object) {

                            _this.props.fetchProfileState();
                            _this.setState({
                                basic: !_this.state.basic
                            })
                        })
                        this.setState({
                            loader: false
                        })
                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });


                    }
                })
        }
    }

    handleBasic = (State) => {
      

        this.setState({
            basic: !this.state.basic
        })
    }
    handleContact(State) {
        if (this.state.address1 === State.address1 && this.state.city === State.city && this.state.state1 === State.state1 && this.state.mobileNumber === State.mobileNumber && this.state.address2 === State.address2 && this.state.homeState === State.homeState && this.state.country === State.country && this.state.emailId === State.emailId && this.state.pincode === State.pincode) {
            this.setState({
                disabledcontact: false
            })
        }
        else {
            this.setState({
                disabledcontact: true
            })
        }
        this.setState({
            contact: !this.state.contact
        })
    }
    handleMailing(State) {
        if (this.state.maddress === State.address && this.state.mcity === State.city && this.state.mstate1 === State.state && this.state.maddress2 === State.address2 && this.state.value3 === State.country && this.state.mpincode === State.pincode) {
            this.setState({
                disabledmail: false
            })
        }
        else {
            this.setState({
                disabledmail: true
            })
        }
        this.setState({
            mailing: !this.state.mailing
        })
    }
    toDate(date) {

        let date1 = new Date(date)
        return date1.getDate() + "/" + parseInt(date1.getMonth() + 1, 10) + "/" + date1.getFullYear()
    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }

        }
    }
    componentWillReceiveProps(nextProps, date) {
       
        if (this.checkObject(nextProps.profileState.body)) {
         
            if (nextProps.profileState.body.mailingInformation === null) {
            
                this.setState({
                    value3: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dobDate,
                    //dateofbirth:this.handleDate(dateOfBirth),
                    //dobDate: nextProps.profileState.body.dateofbirth,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                }, () => {
                   
                })
            } else if (nextProps.profileState.body.mailingInformation !== null) {
                this.setState({
                    value2: nextProps.profileState.body.mailingInformation.country,
                    maddress: nextProps.profileState.body.mailingInformation.address,
                    maddress2: nextProps.profileState.body.mailingInformation.address2,
                    mcity: nextProps.profileState.body.mailingInformation.city,
                    mstate1: nextProps.profileState.body.mailingInformation.state,
                    mpincode: nextProps.profileState.body.mailingInformation.pincode,
                    value3: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dobDate,
                    //dateofbirth:this.handleDate(dateOfBirth),
                    //dobDate: nextProps.profileState.body.dateofbirth,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                })
            } else if (nextProps.profileState.body.profilePicture !== null) {
                this.setState({
                    mediaInfo: nextProps.profileState.body.profilePicture.mediaInfo,
                    value3: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dobDate,
                    //dateofbirth:this.handleDate(dateOfBirth),
                    //dobDate: nextProps.profileState.body.dateofbirth,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                })
            }
        }

        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    cardDetailsId: nextProps.cardState.body[0].cardDetailsId,
                    selectedCard: nextProps.cardState.body[0]
                })
            }
        } catch (e) {

        }


    }

    handleaddress1 = (e, value) => {

        let addval=  value.trim()
        if (value.length !== 0) {
            this.setState({
                address1: addval
            }, () => {
              
                if (this.state.address1!==null && this.state.address1.length !== 0  && this.state.city.length !== 0 &&  this.state.city!==null && this.state.pincode.length !== 0  &&  this.state.pincode!==null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber!==null && this.state.emailId.length !== 0 && this.state.emailId!==null && this.state.state1.length !== 0 && this.state.state1!==null &&this.state.value3.length !== 0 && this.state.value3!==null ) {
                    this.setState({
                        disabledcontact: false
                    },()=>{
                      
                    })
                } else {
                    this.setState({
                        disabledcontact: true
                    })
                }
            })
        }
        else {
            this.setState({
                address1: "",
                disabledcontact: true
            })
        }
    }

    handleaddress2 = (e, value) => {
        let addval=  value.trim()
        if (value.length !== 0) {
            this.setState({
                address2: addval,
            }, () => {
               
                if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                    this.setState({
                        disabledcontact: false
                    })
                } else {
                    this.setState({
                        disabledcontact: true
                    })
                }
            })
        }
        else {
            if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                this.setState({
                    disabledcontact: false
                })
            } else {
                this.setState({
                    address2: "",
                    disabledcontact: true
                })
            }
           
        }
    }

    handlestate1 = (e, value) => {
        let addval=  value.trim()
        if (value.length !== 0) {
            this.setState({
                state1: addval
            }, () => {
                if (this.state.address1!==null && this.state.address1.length !== 0  && this.state.city.length !== 0 &&  this.state.city!==null && this.state.pincode.length !== 0  &&  this.state.pincode!==null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber!==null && this.state.emailId.length !== 0 && this.state.emailId!==null && this.state.state1.length !== 0 && this.state.state1!==null &&this.state.value3.length !== 0 && this.state.value3!==null) {
                    this.setState({
                        disabledcontact: false
                    })
                } else {
                    this.setState({
                        disabledcontact: true
                    })
                }
            })
        }
        else {
            this.setState({
                state1: "",
                disabledcontact: true
            })
        }
    }

    handelemail = (e, value) => {
        let addval=  value.trim()
        if (e.target.name === "emailId" && value.length !== 0) {
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(addval)) {
                this.setState({
                    correctEmail: true,
                    emailId: addval,

                }, () => {               
                    if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0  && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                        this.setState({
                            disabledcontact: false
                        })
                    } else {
                        this.setState({
                            disabledcontact: true
                        })
                    }
                })
            } else {
                this.setState({
                    correctEmail: false,

                })
            }
        }
        else {
            this.setState({
                emailId: "",
                disabledcontact: true
            })
        }
    }

    handelmobileNumber = (e, value) => {
        let addval=  value.trim()
        var regx = /^[0-9]{8,15}$/
        if (e.target.name === 'mobileNumber' && value.length !== 0) {
            if (regx.test(addval)) {
                this.setState({
                    correctphone: true,
                    mobileNumber: addval,

                }, () => {
                    if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                        this.setState({
                            disabledcontact: false
                        })
                    } else {
                        this.setState({
                            disabledcontact: true
                        })
                    }
                })
            } else {
                this.setState({
                    correctphone: false,

                })
            }
        }
        else {
            this.setState({
                mobileNumber: "",
                disabledcontact: true
            })
        }
    }
    handelhomePhoneNumber = (e, value) => {
        var regx = /^[0-9]{8,15}$/
        if (e.target.name === 'homePhoneNumber' && value.length !== 0) {
            if (regx.test(e.target.value)) {
                this.setState({
                    correcthome: true,
                    homePhoneNumber: e.target.value,

                }, () => {
                    if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                        this.setState({
                            disabledcontact: false
                        })
                    } else {
                        this.setState({
                            disabledcontact: true
                        })
                    }
                })
            } else {
                this.setState({
                    correcthome: false,

                })
            }
        }
        else {
            this.setState({
                disabledcontact: true
            })
        }
    }


    handlecity = (e, value) => {
        let addval=  value.trim()
        if (value.length !== 0) {
            this.setState({
                city: addval
            }, () => {
                if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                    this.setState({
                        disabledcontact: false
                    })
                } else {
                    this.setState({
                        disabledcontact: true
                    })
                }
            })
        }
        else {
            this.setState({
                city: "",
                disabledcontact: true
            })
        }
    }

    // handlecountry = (e, value) => {
   
    //     if (value.length !== 0) {
    //         this.setState({
    //             value3: value
    //         }, () => {
    //             if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.address2.length !== 0 && this.state.state1.length !== 0 && this.state.homePhoneNumber.length !== 0 && this.state.value3.length !== 0) {
    //                 this.setState({
    //                     disabledcontact: false
    //                 })
    //             } else {
    //                 this.setState({
    //                     disabledcontact: true
    //                 })
    //             }
    //         })
    //     }
    //     else {
    //         this.setState({
    //             disabledcontact: true
    //         })
    //     }
    // }

    handlepincode = (e, value) => {
        let addval=  value.trim()
        // var regx = /(^\d{6}$)|(^\d{6}-\d{5}$)/;
        var regx = /^[0-9]{4,4}$/
        if (e.target.name === "pincode" && value.length !== 0) {
            if (regx.test(addval)) {
                this.setState({
                    correctpasscode: true,
                    pincode: addval,

                }, () => {
                    if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
                        this.setState({
                            disabledcontact: false
                        })
                    } else {
                        this.setState({
                            disabledcontact: true
                        })
                    }
                })
            } else {
                this.setState({
                    correctpasscode: false,

                })
            }
        }
        else {
            this.setState({
                pincode: "",
                disabledcontact: true
            })
        }
    }

    handlemaddress1 = (e, value) => {
       
        // var regexSpace = /^\s*-/;
      let addval=  value.trim()

    
        if (value.length !== 0) {
            // if (regexSpace.test(value)) {

            this.setState({
                maddress: addval
            }, () => {
            
                if (this.state.maddress !== null && this.state.maddress.length !== 0 && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.value2 !== "") {
                    this.setState({
                        disabledmail: false
                    })
                } else {
                    this.setState({
                        disabledmail: true
                    })
                }
            })
            // }
            // else{
            //     this.setState({
            //         disabledmail: true
            //     })
            // }
        }
        else {
            this.setState({
                maddress: "",
                disabledmail: true
            })
        }
    }

    handlemaddress2 = (e, value) => {
       let addval= value.trim()
      
        if (value.length !== 0) {
            this.setState({
                maddress2: addval,


            }, () => {
                if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.value2 !== "") {
                    this.setState({
                        disabledmail: false
                    })
                } else {
                    this.setState({
                        disabledmail: true
                    })
                }
            })
        }
        else {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.value2 !== "") {
                this.setState({
                    disabledmail: false
                })
            } else {
                this.setState({
                    maddress2: "",
                    disabledmail: true
                })
            }
        }

    }
    // handlePress=()=>{
    //     var regexSpace= /^[^-\s][a-zA-Z0-9_\s-]+$/
    // }

    handlemstate1 = (e, value) => {
      let addval=  value.trim()
       
        if (value.length !== 0) {
            this.setState({
                mstate1: addval
            }, () => {
                if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.value2 !== "") {
                   
                    this.setState({
                        disabledmail: false
                    })
                } else {
                    this.setState({
                        disabledmail: true
                    })
                }
            })
        } else {
            this.setState({
                mstate1: "",
                disabledmail: true
            })
        }
    }
    handleSpace = (e,value) => {
       
      
        // $(function() {
        //     $('body').on('keydown', '#maddress', function(e) {
     
        //       if (e.which === 32 ) {
        //         return false;
        //       }  
        //     });
        //   });
       
        // if (e.keyCode === 32) {
       
        //     return false;
        // }
    }

    handlemcity = (e, value) => {
        let addval=  value.trim()
       
        if (value.length !== 0) {
                this.setState({
                    mcity: addval
                }, () => {
                    if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.value2 !== "") {
                        this.setState({
                            disabledmail: false
                        })
                    } else {
                        this.setState({
                            disabledmail: true
                        })
                    }
                })
           
        } else {
            this.setState({
                mcity: "",
                disabledmail: true
            })
        }
    }

    handlemcountry = (e, value) => {
      
        if (value.length !== 0) {
            this.setState({
                value2: value
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
                    this.setState({
                        disabledmail: false
                    })
                } else {
                    this.setState({
                        disabledmail: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmail: true
            })
        }
    }

    handlempincode = (e, value) => {
        let addval=  value.trim()
        
        var regx = /^[0-9]{4,4}$/
        if (e.target.name === "mpincode" && value.length !== 0) {
                if (regx.test(addval)) {
                    this.setState({
                        correctMpasscode: true,
                        mpincode: addval,

                    }, () => {
                        if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.value2 !== "") {
                            this.setState({
                                disabledmail: false
                            })
                        } else {
                            this.setState({
                                disabledmail: true
                            })
                        }
                    })
                }
                else {
                    this.setState({
                        correctMpasscode: false,

                    })
                }
            
        } else {
            this.setState({
                mpincode: "",
                // disabledmail: true
            })
        }
    }



    handlemaddress1empty = (e, value) => {
        
        if (value.length !== 0) {
            this.setState({
                maddress: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }

    handlemaddress2empty = (e, value) => {
      
        if (value.length !== 0) {
            this.setState({
                maddress2: value
            })
        }
    }

    handlemstate1empty = (e, value) => {
     
        if (value.length !== 0) {
            this.setState({
                mstate1: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }


    handlemcityempty = (e, value) => {
      
        if (value.length !== 0) {
            this.setState({
                mcity: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }

    handlemcountryempty = (e, value) => {
      
        if (value.length !== 0) {
            this.setState({
                value2: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }

    }


    handlempincodeempty = (e, value) => {
      
        var regx = /(^\d{6}$)|(^\d{6}-\d{5}$)/;
        if (e.target.name === "mpincode" && value.length !== 0) {
            if (regx.test(value)) {
                this.setState({
                    correctpasscode: true,
                    mpincode: value,
                    disabledmailempty: false

                })
            } else {
                this.setState({
                    correctpasscode: false,
                    disabledmailempty: true

                })
            }
        }
    }
    // onChangecontact = (e, value) => {

    //     if(e.target.name="maddress"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 maddress: value
    //             }, () => {
   
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         }
    //         else {
    //             this.setState({
    //                 maddress: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }
    //     else if(e.target.name === "mcity"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 mcity: value
    //             }, () => {
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         } else {
    //             this.setState({
    //                 mcity: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }
    //     else if(e.target.name === "mpincode"){
    //         var regx = /^[0-9]{4,4}$/
    //         if (e.target.name === "mpincode" && value.length !== 0) {
    //             if (regx.test(value)) {
    //                 this.setState({
    //                     correctMpasscode: true,
    //                     mpincode: value,

    //                 }, () => {
    //                     if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                         this.setState({
    //                             disabledmail: false
    //                         })
    //                     } else {
    //                         this.setState({
    //                             disabledmail: true
    //                         })
    //                     }
    //                 })
    //             } else {
    //                 this.setState({
    //                     correctMpasscode: false,

    //                 })
    //             }
    //         } else {
    //             this.setState({
    //                 mpincode: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }
    //     else if(e.target.name === "maddress2"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 maddress2: value,


    //             }, () => {
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         }
    //         else {
    //             this.setState({
    //                 maddress2: "",
    //                 disabledmail: false
    //             })
    //         }

    //     }
    //     else if(e.target.name==="mstate1"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 mstate1: value
    //             }, () => {
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         } else {
    //             this.setState({
    //                 mstate1: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }





    //         // this.setState({
    //         //     [e.target.name]: e.target.value
    //         // })
    //         // if (this.state.maddress !== 0 && this.state.mcity.length !== 0 && this.state.mpincode !== null && this.state.mstate1 !== null && this.state.country.length !== 0 && this.state.country !== "No Country Found") {

    //         //     this.setState({
    //         //         disabledmail: false
    //         //     })
    //         // } else {
    //         //     this.setState({
    //         //         disabledmail: true
    //         //     })
    //         // }


    // }

    handleSelect1 = (event, index, value) => {

        this.setState({ cardDetailsId: value });

    }
    render() {
        const { basic, contact, mediaInfo, homeState, correcthome, correctstate, correctcountry, phoneState, mailing, correctphone, emailState, cityState, correctpasscode, pincodeState, correctEmail, addState, correctCity, stateState, value3, value2, value5, correctadd, selectedCard, cardDetailsId, suggestions, countryCode, gender, address2, homePhoneNumber, correctMCity, correctMpasscode, correctMadd, coreectfirstName, correctMstate, correctMcountry, mstateState, maddState, mpinState, mcityState } = this.state
        const { profileState, cardState } = this.props

       
        const { value1, value } = this.state;

        const inputProps = {
            placeholder: "Country",
            value: value3,
            maxLength: 50,
            onChange: this.onChange1

        };
        const inputProps1 = {
            placeholder: "Country",
            value: value2,
            onChange: this.onChange2,
            maxLength: 50,
            name: "country",

        }
        return (
            <div>
                {this.state.loader ? <div style={{ marginTop: "200px" }}><Loader /></div> :
                    <div className="row">

                        {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 &&
                            <div className="col-md-12 nopadding">
                                <div className="row">
                                    <div className="col-md-3" style={{ marginTop: "6px", marginLeft: "40px" }}>
                                        <span style={{ fontSize: "17px", fontWeight: "600", color: "#585555" }}>
                                            {selectedCard.cardProgramId}
                                        </span>
                                    </div>
                                    <div className="offset-md-1 col-md-7 text-right pull-right">
                                        <div className="row">
                                            <div className="col-md-4 input-icon" >
                                                <label style={{ fontWeight: "bold", color: "#585555", marginTop: "8px" }}>Card Number : </label>
                                            </div>
                                            <div className="col-md-8" >
                                                <SelectField
                                                    floatingLabelText=""
                                                    onChange={this.handleSelect1}
                                                    className="input-width"
                                                    name="Selected Card"
                                                    style={{ marginTop: -12 }}
                                                    value={cardDetailsId}>
                                                    {cardState.body.map((value, i) =>
                                                        <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                    )}
                                                </SelectField>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>}
                        {profileState.status === 200 ?
                            <div className="col-md-12" style={{ padding: "0px 30px" }}>
                                <div className="summary-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span>Basic Information</span>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            {basic ? <span style={{ cursor: "pointer" }} onClick={(e) => this.handleBasic(profileState)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i>Edit</span>
                                                :
                                                <span style={{ cursor: "pointer" }} onClick={this.handleBasic}><i className="fa fa-times" aria-hidden="true"></i>Cancel</span>}
                                        </div>
                                    </div>
                                </div>

                                {
                                    basic ?
                                        <div className="tile box-shadow-style">
                                            < div className="row">
                                                <div className="col-md-3 col-sm-6">
                                                    <a className="profile-pic" data-toggle="modal" data-target="#dpupdate">
                                                        {profileState.body.profilePicture !== null ?
                                                            <div className="profile-pic img-circle img-responsive img-bordered-primary profile_image_modifaction" style={{ backgroundImage: `url(${"data:image/jpeg;base64," + profileState.body.profilePicture.mediaInfo || defaultImage})` }} >

                                                                <span className="glyphicon glyphicon-camera"></span>
                                                                <span style={{ cursor: "pointer" }}  >Update Picture</span>
                                                            </div>
                                                            : <div className="profile-pic img-circle img-responsive img-bordered-primary profile_image_modifaction" style={{ backgroundImage: `url(${defaultImage})` }} >

                                                                <span className="glyphicon glyphicon-camera"></span>
                                                                <span style={{ cursor: "pointer" }}  >Update Picture</span>
                                                            </div>}
                                                    </a>
                                                    <ProfileUpdateModal />
                                                </div>
                                                <div className="col-md-9 col-sm-12">
                                                    <div className="row" style={{ padding: "25px 8px" }}>
                                                        <div className="col-md-5">
                                                            <div className="row">
                                                                <div className="col-md-4 tilepadding">
                                                                    <label className="tilecontent">First Name </label>
                                                                </div>
                                                                <div className="col-md-8 text-left tilepadding">
                                                                    <span className="tileheadername">{profileState.body.firstName} </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-4 tilepadding">
                                                                    <label className="tilecontent">Gender </label>
                                                                </div>
                                                                <div className="col-md-8 text-left tilepadding">
                                                                    <span className="tileheadername">{profileState.body.gender}  </span><br />
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="row">
                                                                <div className="col-md-6 tilepadding">
                                                                    <label className="tilecontent">Last Name </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> {profileState.body.lastName} </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6  tilepadding">
                                                                    <label className="tilecontent">Date of Birth </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername">{profileState.body.dateofbirth} </span><br />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="tile box-shadow-style">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-12">
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 personalinfoinput" >
                                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10" >
                                                            <TextField
                                                                hintText="Type Your First Name"
                                                                floatingLabelText="First Name"
                                                                type="text"
                                                                name="firstName"
                                                                maxLength="30"
                                                                defaultValue={profileState.body.firstName || null}
                                                                className="input-width required"
                                                                onChange={this.handleFirstName}
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                underlineStyle={styles.underlineStyle1}
                                                                errorText={coreectfirstName ? null : "Not a valid name"} 
                                                                disabled
                                                                />
                                                        </div>
                                                    </div>
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 input-icon" >
                                                            <i className="fa fa-neuter" aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10" >
                                                            <SelectField
                                                                floatingLabelText="Gender"
                                                                value={gender || profileState.body.gender}
                                                                defaultValue={profileState.body.gender || this.state.gender}
                                                                onChange={this.handleGender}
                                                                className="input-width required"
                                                                name="gender"
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}>
                                                                <MenuItem value="Male" primaryText="Male" />
                                                                <MenuItem value="Female" primaryText="Female" />
                                                                <MenuItem value="Others" primaryText="Others" />
                                                            </SelectField>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 input-icon" >
                                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10" >
                                                            <TextField
                                                                hintText="Type Your Last Name"
                                                                floatingLabelText="Last Name"
                                                                type="text"
                                                                name="lastName"
                                                                maxLength="30"
                                                                defaultValue={profileState.body.lastName || null}
                                                                className="input-width "
                                                                underlineStyle={styles.underlineStyle1}
                                                                onChange={this.handleLastName}
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{ padding: "23px 0px" }}>
                                                        <div className="col-sm-2 input-icon" >
                                                            <i className="fa fa-birthday-cake text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10" >
                                                            <DatePicker hintText="Birthday" container="inline" mode="landscape"
                                                                className="input-width required"
                                                                style={{ width: "100%" }}
                                                                type="text"
                                                                name="dateofbirth"
                                                                defaultDate={(profileState.body.dobDate) ? new Date(profileState.body.dobDate) : new Date()}
                                                                onChange={this.handleDate}
                                                                formatDate={this.formatDate}
                                                                maxDate={new Date()}
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="offset-md-5 col-md-5 col-sm-5">
                                                    <div className="row input-group float-right" >
                                                        <RaisedButton
                                                            label="Update"
                                                            disabled={this.state.disabled}
                                                            onClick={this.handleSubmit}
                                                            style={styles.button}
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                        />
                                                    </div>{this.state.loader === true &&
                                                        <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                            <LoaderSmall />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>}
                            </div>
                            : <div></div>}

                        <div className="col-md-12" style={{ padding: "0px 30px" }}>
                            <div className="summary-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <span>Contact Information</span>
                                    </div>
                                    <div className="col-md-6 text-right">
                                        {contact ? <span style={{ cursor: "pointer" }} onClick={(e) => this.handleContact(profileState)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i>Edit</span>
                                            :
                                            <span style={{ cursor: "pointer" }} onClick={this.handleContact}><i className="fa fa-times" aria-hidden="true"></i>Cancel</span>}
                                    </div>
                                </div>
                            </div>

                            {contact ?
                                <div className="tile box-shadow-style">
                                    {profileState.status === 200 ?
                                        <div className="row">
                                            <div className="col-md-7 col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-3  tilepadding">
                                                        <label className="tilecontent">Address</label>
                                                    </div>
                                                    <div className="col-md-8 tilepadding" >
                                                        <span className="tileheadername" style={{ wordWrap: "break-word" }}>{(profileState.body.address !== "" && profileState.body.address !== null) ? profileState.body.address + "," : ""}</span>
                                                        <span style={{ wordWrap: "break-word" }}>{(profileState.body.address2 !== "" && profileState.body.address2 !== null) ? " " + profileState.body.address2 + "," : ""}</span><br />
                                                        <span style={{ wordWrap: "break-word" }}>{(profileState.body.city !== "" && profileState.body.city !== null) ? " " + profileState.body.city + "," : ""}</span>
                                                        <span style={{ wordWrap: "break-word" }}>{(profileState.body.state !== "" && profileState.body.state !== null) ? " " + profileState.body.state + "," : ""}</span>
                                                        <span style={{ wordWrap: "break-word" }}>{(profileState.body.pincode !== "" && profileState.body.pincode !== null) ? " " + profileState.body.pincode + "," : ""}</span><br />
                                                        <span style={{ wordWrap: "break-word" }}>{(profileState.body.country !== "" && profileState.body.country !== null) ? " " + profileState.body.country + "." : ""}</span><br />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-5 col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-5  tilepadding">
                                                        <label className="tilecontent">Home Phone No</label>
                                                    </div>
                                                    <div className="col-md-7 text-left tilepadding">
                                                        <span className="tileheadername">{profileState.body.homePhoneNumber} </span><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-5  tilepadding">
                                                        <label className="tilecontent">Mobile Phone No</label>
                                                    </div>
                                                    <div className="col-md-7 text-left tilepadding">
                                                        <span className="tileheadername">{profileState.body.mobileNumber} </span><br />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-5  tilepadding" >
                                                        <label className="tilecontent" >Email</label>
                                                    </div>
                                                    <div className="col-md-7 text-left tilepadding">
                                                        <span className="tileheadername" style={{ wordWrap: "break-word" }}>{profileState.body.emailId} </span><br />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : <div></div>}

                                </div>
                                :
                                <div className="tile box-shadow-style">
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <i className="fa fa-address-book text-dark " aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="Address Line 1"
                                                        type="text"
                                                        name="address1"
                                                        maxLength="60"
                                                        defaultValue={profileState.body.address || null}
                                                        className="input-width required"
                                                        onChange={this.handleaddress1}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        onFocus={this.removeadd}
                                                        errorText={addState ? correctadd ? null : "Not a valid address" : "This field is required"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <img src={cityimg} alt="" />
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="City"
                                                        defaultValue={profileState.body.city || null}
                                                        type="text"
                                                        name="city"
                                                        maxLength="30"
                                                        className="input-width required"
                                                        onChange={this.handlecity}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        onFocus={this.removecity}
                                                        underlineStyle={styles.underlineStyle1}
                                                        errorText={cityState ? correctCity ? null : "Not a valid city" : "This field is required"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <img src={postalimg} alt="" />
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="Postal Code"
                                                        type="number"
                                                        defaultValue={profileState.body.pincode || null}
                                                        name="pincode"
                                                        onInput={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                                                        }}
                                                        maxLength="6"
                                                        className="input-width required "
                                                        onChange={this.handlepincode}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        onFocus={this.removepasscode}
                                                        errorText={pincodeState ? correctpasscode ? null : "Not a valid Pincode" : "This field is required"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <i className="fa fa-mobile text-dark " aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="Mobile Phone Number"
                                                        type="number" step="1"
                                                        defaultValue={profileState.body.mobileNumber || null}
                                                        name="mobileNumber"
                                                        maxLength="15"
                                                        onInput={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                        }}
                                                        className="input-width required"
                                                        onChange={this.handelmobileNumber}
                                                        onFocus={this.removephone}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={correctphone ? null : "Not a valid phone number"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <i className="fa fa-envelope text-dark" aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="E-Mail"
                                                        type="text"
                                                        defaultValue={profileState.body.emailId || null}
                                                        name="emailId"
                                                        maxLength="50"
                                                        className="input-width required"
                                                        onChange={this.handelemail}

                                                        onFocus={this.removeemail}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={emailState ? correctEmail ? null : "Not a valid email" : "This field is required"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <div className="row input-group" >
                                                <div className="col-sm-2 input-icon" >
                                                    <i className="fa fa-address-book text-dark " aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="Address Line 2"
                                                        type="text"
                                                        defaultValue={profileState.body.address2 || null}
                                                        name="address2"
                                                        maxLength="60"
                                                        className="input-width"
                                                        onChange={this.handleaddress2}

                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="State"
                                                        type="text"
                                                        defaultValue={profileState.body.state || null}
                                                        name="state1"
                                                        maxLength="50"
                                                        className="input-width required"
                                                        onChange={this.handlestate1}
                                                        onFocus={this.removestate}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        underlineStyle={styles.underlineStyle1}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={stateState ? correctstate ? null : "Not a valid state" : "This field is required"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 input-icon" >
                                                    <i className="fa fa-flag text-dark" aria-hidden="true"></i>
                                                </div>
                                                {/* <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="Country"
                                                        type="text"
                                                        defaultValue={value3 || null}
                                                        name="state1"
                                                        maxLength="50"
                                                        className="input-width required"                                       
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={correctcountry ? null : "Not a valid name"}
                                                        disabled
                                                    />
                                                </div> */}
                                                <div className="col-sm-10" >
                                                    <div className="col-sm-12 nopadding count" style={{ marginBottom: "0px !important", color: "#b4b4b4", fontSize: "12px", marginTop: "5px" }}>

                                                        <label className="form-control-placeholder "
                                                            onChange={this.handlecountry} name="country" id="required" style={{ position: "relative", top: "10px", cursor: "pointer" }}>Country</label>
                                                    </div>
                                                    <div className="col-sm-12 " style={{ padding: "0px", cursor: "pointer" }}>
                                                        <Autosuggest

                                                            suggestions={suggestions}
                                                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                            getSuggestionValue={this.getSuggestionValue}
                                                            renderSuggestion={this.renderSuggestion}
                                                            onSuggestionSelected={this.onSuggestionSelected}
                                                            inputProps={inputProps}
                                                            errorText={correctcountry ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row input-group" >
                                                <div className="col-sm-2 personalinfoinput" >
                                                    <i className="fa fa-phone-square text-dark" aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-10" >
                                                    <TextField
                                                        hintText="Start Typing"
                                                        floatingLabelText="Home Phone Number"
                                                        type="number"
                                                        name="homePhoneNumber"
                                                        defaultValue={profileState.body.homePhoneNumber || null}
                                                        className="input-width"
                                                        maxLength="15"
                                                        onInput={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                        }}
                                                        onChange={this.handelhomePhoneNumber}
                                                        onFocus={this.removehome}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                    />
                                                </div>
                                                <div className="offset-md-5 col-md-5 col-sm-5">
                                                    <div className="row input-group float-right" >
                                                        <RaisedButton
                                                            label="Update"
                                                            disabled={this.state.disabledcontact}
                                                            onClick={this.handleContactSubmit}
                                                            style={styles.button}
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                        />
                                                    </div>
                                                    {this.state.loader === true &&
                                                        <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                            <LoaderSmall />
                                                        </div>}
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                </div>}
                        </div>

                        <div className="col-md-12" style={{ padding: "0px 30px" }}>
                            <div className="summary-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <span>Mailing Information</span>
                                    </div>
                                    <div className="col-md-6 text-right">
                                        {mailing ? <span style={{ cursor: "pointer" }} onClick={(e) => this.handleMailing(profileState)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> <a src=""> Edit</a></span>
                                            :
                                            <span style={{ cursor: "pointer" }} s onClick={this.handleMailing}><i className="fa fa-times" aria-hidden="true"></i>Cancel</span>}
                                    </div>
                                </div>
                            </div>
                            {mailing ?
                                <div className="tile box-shadow-style">
                                    {(profileState.status === 200 && profileState.body.mailingInformation !== null) ?
                                        <div className="row">
                                            <div className="col-md-7 col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-3  tilepadding">
                                                        <label className="tilecontent">Address</label>
                                                    </div>
                                                    <div className="col-md-8 tilepadding" style={{ textAlign: "justify" }}>
                                                        {profileState.body.mailingInformation !== null &&
                                                            <div>
                                                                <span className="tileheadername">{(profileState.body.mailingInformation.address !== "") ? profileState.body.mailingInformation.address + "," : ""}</span>
                                                                <span>{(profileState.body.mailingInformation.address2 !== "") ? " " + profileState.body.mailingInformation.address2 + "," : ""}</span><br />
                                                                <span>{" " + profileState.body.mailingInformation.city + ","}</span>
                                                                <span>{" " + profileState.body.mailingInformation.state + ","}</span>

                                                                <span>{" " + profileState.body.mailingInformation.pincode}</span><br />
                                                                <span>{" " + profileState.body.mailingInformation.country}</span><br />

                                                            </div>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="col-md-5 col-sm-12">
                                            <div className="row">
                                                <div className="col-md-6  tilepadding">
                                                    <label className="tilecontent">Home Phone Number :</label>
                                                </div>
                                                <div className="col-md-6 text-left tilepadding">
                                                    <span className="tileheadername">{profileState.body.mailingInformation.homePhoneNumber} </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6  tilepadding">
                                                    <label className="tilecontent">Mobile Phone Number:</label>
                                                </div>
                                                <div className="col-md-6 text-left tilepadding">
                                                    <span className="tileheadername">{profileState.body.mailingInformation.mobileNumber} </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6  tilepadding">
                                                    <label className="tilecontent">Email:</label>
                                                </div>
                                                <div className="col-md-6 text-left tilepadding">
                                                    <span className="tileheadername">{profileState.body.mailingInformation.email} </span><br />
                                                </div>
                                            </div> */}
                                            {/* </div> */}
                                        </div>
                                        : <div></div>}
                                </div>
                                :
                                <div className="tile box-shadow-style">
                                    {(profileState.status === 200 && profileState.body.mailingInformation !== null) ?
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <i className="fa fa-address-book text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="Address Line 1"
                                                            defaultValue={profileState.body.mailingInformation.address || null}
                                                            type="text"
                                                            name="maddress"
                                                            maxLength="60"
                                                            className="input-width required"
                                                            onFocus={this.removeMadd}
                                                            onKeyDown={(e)=>{this.handleSpace}}
                                                            onChange={this.handlemaddress1}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMadd ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <img src={cityimg} alt="" />
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            defaultValue={profileState.body.mailingInformation.city || null}
                                                            floatingLabelText="City"
                                                            type="text"
                                                            name="mcity"
                                                            maxLength="30"
                                                            className="input-width required"
                                                            onFocus={this.removeMcity}
                                                            onChange={this.handlemcity}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMCity ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <img src={postalimg} alt="" />
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="Postal Code"
                                                            defaultValue={profileState.body.mailingInformation.pincode || null}
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                                                            }}
                                                            type="number"
                                                            name="mpincode"
                                                            maxLength="6"
                                                            className="input-width required"
                                                            onFocus={this.removeMpasscode}
                                                            onChange={this.handlempincode}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMpasscode ? null : "Not a valid Pincode"}
                                                        />
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 input-icon" >
                                                        <i className="fa fa-address-book text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="Address Line 2"
                                                            type="text"
                                                            defaultValue={profileState.body.mailingInformation.address2 || null}
                                                            name="maddress2"
                                                            maxLength="60"
                                                            className="input-width "
                                                            onChange={this.handlemaddress2}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="State"
                                                            type="text"
                                                            defaultValue={profileState.body.mailingInformation.state || null}
                                                            name="mstate1"
                                                            maxLength="50"
                                                            className="input-width required"
                                                            onFocus={this.removeMstate}
                                                            onChange={this.handlemstate1}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMstate ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 input-icon" >
                                                        <i className="fa fa-flag text-dark" aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <div className="col-sm-12 nopadding " style={{ marginBottom: "0px !important", color: "#b4b4b4", fontSize: "12px", marginTop: "5px" }}>
                                                            <label className="form-control-placeholder" name="country" onChange={this.handlemcountry} id="required" style={{ position: "relative", top: "10px", cursor: "pointer" }}>Country</label>
                                                        </div>
                                                        <div className="col-sm-12 " style={{ padding: "0px", cursor: "pointer" }}>

                                                            <Autosuggest
                                                                suggestions={suggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                getSuggestionValue={this.getSuggestionValue}
                                                                renderSuggestion={this.renderSuggestion}
                                                                onSuggestionSelected={this.onSuggestionSelected1}
                                                                inputProps={inputProps1}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row input-group" >
                                                <div className="offset-md-5 col-md-5 col-sm-5">
                                                    <div className="row input-group float-right" >
                                                        <RaisedButton
                                                            label="Update"
                                                            disabled={this.state.disabledmail}
                                                            onClick={this.handleMailingSubmit}
                                                            style={styles.button}
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                        />
                                                    </div>
                                                    {this.state.loader === true &&
                                                        <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                            <LoaderSmall />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <i className="fa fa-address-book text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="Address Line 1"
                                                            style={{ wordBreak: "break-all" }}
                                                            id=""
                                                            type="text"
                                                            name="maddress"
                                                            maxLength="100"
                                                            className="input-width required"
                                                            onFocus={this.removeMadd}
                                                            onKeyDown={(e)=>{this.handleSpace}}
                                                            onChange={this.handlemaddress1}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMadd ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <img src={cityimg} alt="" />
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            maxLength="30"
                                                            floatingLabelText="City"
                                                            type="text"
                                                            style={{ wordBreak: "break-all" }}
                                                            name="mcity"
                                                            className="input-width required"
                                                            onFocus={this.removeMcity}
                                                            onChange={this.handlemcity}
                                                            onKeyPress={(e)=>{this.handleSpace}}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMCity ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <img src={postalimg} alt="" />
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="Postal Code"

                                                            type="number"
                                                            name="mpincode"
                                                            maxLength="6"
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                                                            }}
                                                            className="input-width required"
                                                            onFocus={this.removeMpasscode}
                                                            onChange={this.handlempincode}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMpasscode ? null : "Not a valid pincode"}
                                                        />
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 input-icon" >
                                                        <i className="fa fa-address-book text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="Address Line 2"
                                                            type="text"
                                                            style={{ wordBreak: "break-all" }}
                                                            name="maddress2"
                                                            maxLength="100"
                                                            className="input-width "
                                                            onChange={this.handlemaddress2}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row input-group">
                                                    <div className="col-sm-2 personalinfoinput" >
                                                        <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <TextField
                                                            hintText="Start Typing"
                                                            floatingLabelText="State"
                                                            type="text"
                                                            style={{ wordBreak: "break-all" }}
                                                            name="mstate1"
                                                            maxLength="50"
                                                            className="input-width required"
                                                            onFocus={this.removeMstate}
                                                            onChange={this.handlemstate1}
                                                        
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            errorText={correctMstate ? null : "Not a valid name"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 personalinfoinput">
                                                        <i className="fa fa-flag text-dark" aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <div className="col-sm-12 nopadding" style={{ color: "#b4b4b4", fontSize: "12px", marginTop: "5px" }}>
                                                            <label className="form-control-placeholder" onChange={this.handlemcountryempty} name="" id="required" style={{ position: "relative", top: "10px", cursor: "pointer" }}>Country</label>
                                                        </div>
                                                        <div className="col-sm-12 " style={{ padding: "0px", cursor: "pointer" }}>

                                                            <Autosuggest
                                                                suggestions={suggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                getSuggestionValue={this.getSuggestionValue}
                                                                renderSuggestion={this.renderSuggestion}
                                                                onSuggestionSelected={this.onSuggestionSelected2}
                                                                inputProps={inputProps1}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="row input-group" >
                                                <div className="offset-md-5 col-md-4 col-sm-5">
                                                    <div className="row input-group float-right" >
                                                        <RaisedButton
                                                            label="Update"
                                                            disabled={this.state.disabledmail}
                                                            onClick={this.handleMailingSubmit}
                                                            style={styles.button}
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                        />
                                                    </div>
                                                    {this.state.loader === true &&
                                                        <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                            <LoaderSmall />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>}
                        </div>

                    </div>}

            </div>
        );
    }
}
PersonalInfo.defaultProps = {
    profileState: {
        status: 600
    },
    cardState: {
        status: 600
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);


// WEBPACK FOOTER //
// ./src/components/myprofile/personalinfo.jsx